import { withInstall } from '@ideaz/utils'
import Input from './src/index'

export default withInstall(Input)
export * from './src/input'
